import apiClient from "@/axios.js";
import endpoints from "@/endpoints";
import axios from "axios";
const PREPR_API = process.env.VUE_APP_PREPR_API;

export async function getVikingResult(barcode) {
  const { data } = await apiClient.get(endpoints.vikingResult(barcode), {});
  return data;
}

const populations = {
  "Population-A": {
    title: "Population A",
    slug: "Population-A",
    id: "71361",
    heading: "Great Britain, Ireland & Iceland",
    text: "<p>The Viking raid on the monastery at Lindisfarne in 793 AD is commonly considered the first of such raids in the British Isles. In the following years they also raided Monkwearmouth-Jarrow Abbey on the coast of Northumbria, and Iona Abbey on the coast of Scotland.</p>\n<p>Vikings began settling on captured land from around 860 AD onwards, mainly in the north and east of England, at the time known as the kingdoms of Anglia, Mercia and Northumbria. In 886 AD King Alfred of the Kingdom of Wessex agreed that the Vikings could rule territories in Northumbria and Anglia. These Viking ruled territories were known as the Danelaw. However, soon after Saxon Kings sought to retake these lands by force.</p>\n<p>Islands to the north and west of Great Britain were settled by Norsemen from Norway. These included Iceland, Orkney, and the Faroe Islands to the north, where the Norsemen became fishermen and farmers. Orkney developed into a regional power that ruled the coastal regions of Scotland. To the west of Great Britain in the Irish Sea the Isle of Man was settled and became a Viking kingdom. Between 879 and 920 AD a colony was founded in Iceland. This became the origin for the colonisation of Greenland, and then North America. The remains of a Viking settlement at L’Anse aux Meadows in Newfoundland have been carbon dated to one millennia ago.</p>\n<p>The Vikings of Scandinavian Scotland mounted the first recorded raids on Ireland in 795 AD. After exploring for opportunities along the Irish coast and inland rivers by 812 AD the Viking raiders had reached as far as the south west. Then, after a pause of several years, the raiding became more intensive. This led to the first permanent occupations in Dublin in 841 AD.</p>",
    mainImage: {
      title: "GB IRL ICE MAP",
      urlHero:
        "https://static.livingdna.com/images/wellbeing/_heroCrop/GB_IRL_ICE_MAP.png?mtime=20220202140512&focal=none",
      urlRaw: "https://static.livingdna.com/images/wellbeing/GB_IRL_ICE_MAP.png?mtime=20220202140512&focal=none",
    },
    subImages: [
      {
        title: "Beach raid",
        urlThumbnail:
          "https://static.livingdna.com/images/wellbeing/_productThumbnail/beach_raid.jpg?mtime=20220204134843&focal=none",
        urlRaw: "https://static.livingdna.com/images/wellbeing/beach_raid.jpg?mtime=20220204134843&focal=none",
      },
    ],
    geoJson: null,
  },
};

/**
 * @param {string} populationGroup
 */
export async function getVikingPopulationGroup(populationGroup) {
  // const { data } = await apiClient.get(endpoints.vikingCms(populationGroup));
  const data = populations[populationGroup];
  return data;
}

export async function getVikingIntroduction() {
  const res = await axios.post(PREPR_API, {
    query: `{
                CommonModel (slug: "viking-overview") { 
                        title
                        heading
                        text
                        main_image { 
                                url
                        }
                        right_section { 
                                title
                                heading
                                text
                                main_image {
                                        url
                                }
                                button_text
                        }
                }
                }`
  });
  return res.data.data.CommonModel
}

/* export async function getVikingIntroduction() {
const res = await axios.post(PREPR_API, {
        query: `{
        Viking (id: "1f5a0918-5b8c-4ae6-81c3-21845c913bc1") { 
                title
                introduction {
                        heading
                        image {
                                url
                        }
                        description
                }
                unlock_your_viking_past_today { 
                        heading
                        image {
                                url
                        }
                        description
                        button_text
                }
                discover_your_viking_results_in_detail { 
                        heading
                        image {
                                url
                        }
                        description
                        button_text
                }
                what_is_your_viking_population_group { 
                        heading
                        image {
                                url
                        }
                        description
                        button_text
                }
        }
}`
});
return res
} */

export async function getVikingUnderstanding() {
  const res = await axios.post(PREPR_API, {
    query: `{
                CommonModel (slug: "viking-result") { 
                        title
                        heading
                        main_image { 
                                url
                        }
                        right_section { 
                                title
                                heading
                                text
                                main_image {
                                        url
                                }
                                button_text
                        }
                }
        }`
  });
  return res.data.data.CommonModel;
}

/* export async function getVikingUnderstanding() {
const res = await axios.post(PREPR_API, {
        query: `{
        Result (id: "2895f178-67e3-4dbe-90be-af7ef962e509") { 
                title
                viking_index { 
                        heading
                        description
                        button_text
                }
                to_view_you_viking_index_map_view {
                        heading
                        image {
                                url
                        }
                        button_text
                }
                understanding_your_results {
                        ... on ImageAndText {
                                title
                                image {
                                        url
                                }
                        } 
                        ... on PageContents {
                                heading
                                image {
                                        url
                                }
                                description
                        }
                }
        }
}`
});
return res.data.data.Result;
} */

export async function getVikingMapData() {
  const res = await axios.post(PREPR_API, {
    query: `{
                Map (id: "63c607d9-83d1-44ef-999e-4cda9bbc3037") { 
                        vikings_of_denmark__sweden { 
                description
                image {
                url
                }
                heading
                title
                }
                }
                }`
  });
  return res.data.data.Map;
}

export async function getVikingUpgrade() {
  const res = await axios.post(PREPR_API, {
    query: `{
      CommonUpgrade (slug: "viking-upgrade") { 
        _id
        heading
        title
        content { 
          title
          heading
          image {
                  url
          }
          text
          button_text
        }
        description
        faqs { 
          question
          answer
        }
      }
    }`
  });
  return res.data.data.CommonUpgrade;
}

export async function getVikingUnlock() {
  const res = await axios.post(PREPR_API, {
    query: `{
      CommonUnlock (slug: "unlock-viking") { 
          title
          banner { 
                  title
                  heading
                  image { 
                          url
                  }
                  text
                  button_text
          }
          description { 
                  title
                  heading
                  image { 
                          url
                  }
                  text
          }
        }
      }`
  });
  return res.data.data.CommonUnlock;
}

export async function getVikingResultsCard() {
  const { data } = await apiClient.get(endpoints.vikingCms("vikingResultsCard"));
  return data;
}

export async function getVikingMapCard() {
  const { data } = await apiClient.get(endpoints.vikingCms("vikingMapCard"));
  return data;
}

export async function getVikingReference() {
  const res = await axios.post(PREPR_API, {
    query: `{
                ProductGrouping(slug: "viking-citations") {
                description
                content_reference {
                ... on CitationModel {
                        id
                        title
                        external_url
                }
             }
           }
        }`
  });
  return res.data.data.ProductGrouping
}
